import { Box, FormControl, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import OptionalServicesModal from "../../modal/OptionalServicesModal";
import { OptionalServices } from "../../../models/app";
import CloseIcon from "@mui/icons-material/Close";
import { Switch } from "@mui/material";

const CartItem = ({ updateCart, product, removeFromCart }: any) => {
  const [qty, setQty] = useState(product?.quantity);
  const [options, setOptions] = useState<OptionalServices[]>([
    ...(product.services ?? [])
  ]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setQty(product?.quantity);
  }, [product]);

  const handleChangeQty = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newQty = parseInt(event.target.value);
    if (!isNaN(newQty) && newQty > 0) {
      setQty(newQty);
      product.quantity = newQty;
      updateCart(product);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "white",
        borderBottom: "10px solid #e5e5e5",
        padding: "15px 10px",

        // MOBILE LAYOUT
        display: { xs: "block", sm: "flex" },
        alignItems: { sm: "center" },
        gap: { sm: 1.5 },
      }}
    >

      {/* IMAGE */}
      <Box
        sx={{
          width: { xs: "100%", sm: "10%" },
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: { xs: 2, sm: 0 },
        }}
      >
        <Box
          onClick={() => removeFromCart(product?.id)}
          sx={{
            width: "32px",
            height: "32px",
            border: "1px solid #ccc",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <CloseIcon sx={{ fontSize: "18px" }} />
        </Box>

        <img
          src={
            product?.image ??
            require("../../../assets/images/Default-removebg-preview.png")
          }
          alt={product?.name}
          style={{
            width: "50px",
            height: "50px",
            objectFit: "contain",
          }}
        />
      </Box>

      {/* PRODUCT INFO */}
      <Box
        sx={{
          width: { xs: "100%", sm: "22%" },
          mb: { xs: 2, sm: 0 },
        }}
      >
        <Typography sx={{ fontSize: "12px", color: "#555" }}>
          {product?.brand}
        </Typography>

        <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
          {product?.name}
        </Typography>

        <Typography sx={{ fontSize: "13px", color: "#444" }}>
          {product?.description}
        </Typography>
      </Box>

      {/* QTY */}
      <Box
        sx={{
          width: { xs: "100%", sm: "8%" },
          mb: { xs: 2, sm: 0 },
        }}
      >
        <TextField
          label="Qty"
          type="number"
          value={qty}
          onChange={handleChangeQty}
          size="small"
          InputProps={{ sx: { maxWidth: { xs: "100%", sm: 55 } } }}
          InputLabelProps={{ shrink: true }}
          fullWidth={true}
        />
      </Box>

      {/* PRICE */}
      <Box
        sx={{
          width: { xs: "100%", sm: "12%" },
          mb: { xs: 2, sm: 0 },
        }}
      >
        <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
          Price: ${product?.price?.toFixed(2)}
        </Typography>

        {product.showMessage && (
          <Typography sx={{ fontSize: "12px", color: "blue", mt: 0.5 }}>
            Special Order 1-2 Business Days
          </Typography>
        )}
      </Box>

      {/* OPTIONAL SERVICES */}
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          gap: 1,
          alignItems: "center",

          // MOBILE: horizontal scroll
          overflowX: { xs: "auto", sm: "visible" },
          whiteSpace: { xs: "nowrap", sm: "normal" },

          // DESKTOP: no wrap
          flexWrap: { xs: "nowrap", sm: "nowrap" },

          pb: { xs: 1, sm: 0 },
        }}
      >
        {options.map((service, index) => (
          <Box
            key={index}
            sx={{
              flex: "1 1 auto",
              minWidth: { xs: "150px", sm: "130px" },
              padding: "8px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              background: "#fff",
              display: "inline-block",
            }}
          >
            <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
              {service.ServiceDescription}
            </Typography>

            <Box
              sx={{
                mt: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: "11px", color: "#666" }}>
                ${service.ServicePriceWithTax.toFixed(2)}
              </Typography>

              <Switch
                checked={!!service.Selected}
                onChange={() => {
                  const updated = options.map((s, i) =>
                    i === index ? { ...s, Selected: !s.Selected } : s
                  );

                  setOptions(updated);
                  product.services = updated;
                  updateCart(product);
                }}
                size="small"
                color="success"
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CartItem;
